<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="main-title">{{content.menu_title}}</div>
        <div class="main-sub" v-html="content.title_brief"></div>
        <div class="poster" v-html="richHtml"></div>
        <el-button @click="next">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "eventRegistration",
  data() {
    return {
      loading: false,
      active: 8,
      content: {
        title_brief: ''
      },
      richHtml: ''
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/eventRegistration";
    });
    this.active = index;
    this.id = this.$route.query.id;
    this.getContent(this.id);
  },
  created() {},
  methods: {
    //  获取内容
    getContent(id) {
      this.loading = true;
      getDetail({ id })
        .then((res) => {
          console.log(res, "======菜单进度");
          this.loading = false;
          if (res.code == 200) {
            let { data } = res;
            this.content = data[0];
            if(data[0].step){
              this.content.title_brief = data[0].step.title_brief;
              this.richHtml = data[0].step.app_introduction;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    next() {
     
      this.active = this.active + 1;
      let { link_url, menu_title, id } = this.stepMenuList[this.active];
      if(link_url == '/exhibitorManual' || link_url == '/standPrepare'){
        this.$router.push({
          path: link_url,
          query: { 
            id: id,
            title: menu_title
          }
        });
      }else{
        this.$router.push({
          path: link_url,
          query: { 
            id: id
          }
        });
      }
    }, //修改进度状态
   
  },
};
</script>

<style lang="scss" scoped>
.poster {
  width: 100%;
  display: block;
  margin-top: 50px;
}
.poster /deep/ img{
  max-width: 100%;
}
</style>